import { ISensorsPool, IPlotsPool, ITracksPool, IObjectsPool, IAngularTracksPool, IAlertPolygonsPool, IAcousticVectorPool } from './interfaces';

export var sensorsPool: ISensorsPool = null;
export function setSensorsPool(iSensorsPool) {
  sensorsPool = iSensorsPool;
}

export var plotsPool: IPlotsPool = null;
export function setPlotsPool(iPlotsPool) {
  plotsPool = iPlotsPool;
}

export var tracksPool: ITracksPool = null;
export function setTracksPool(iTracksPool) {
  tracksPool = iTracksPool;
}

export var sensorTracksPool: ITracksPool = null;
export function setSensorTracksPool(iTracksPool) {
  sensorTracksPool = iTracksPool;
}

export var angularTracksPool: IAngularTracksPool = null;
export function setAngularTracksPool(iTracksPool) {
  angularTracksPool = iTracksPool;
}

export var alertPolygonsPool: IAlertPolygonsPool = null;
export function setAlertPolygonsPool(iAlertPolygonsPool) {
  alertPolygonsPool = iAlertPolygonsPool;
}

export var acousticVectorPool: IAcousticVectorPool = null;
export function setAcousticVectorPool(IAcousticVectorPool) {
  acousticVectorPool = IAcousticVectorPool;
}
